// Toastify
import { toast } from "react-toastify";
// Redux
import { configureStore } from "@reduxjs/toolkit";
// Slice
import authReducer from "./Slice/Auth.state";
import settingsReducer from "./Slice/Settings.state";
import drawerReducer from "./Slice/Drawer.state";
import userReducer from "./Slice/User.state";
import gatewayReducer from "./Slice/Gateway.state";
import ticketReducer from "./Slice/Ticket.state";
// Api
import { api } from "./ApiState";
import { authApi } from "./Api/Auth.api";
import { adminApi } from "./Api/Admin.api";
import { bankApi } from "./Api/Bank.api";
import { gatewayApi } from "./Api/Gateway.api";
import { ticketApi } from "./Api/Ticket.api";
import { addressApi } from "./Api/Address.api";
import { transactionApi } from "./Api/Transaction.api";
import { marketingApi } from "./Api/Marketing.api";
import { walletApi } from "./Api/Wallet.api";
import { withdrawApi } from "./Api/Withdraw.api";
import { gatewayAdminApi } from "./Api/GatewayAdmin.api";
import { newsApi } from "./Api/News.api";
import { eventApi } from "./Api/Event.api";
import { serviceApi } from "./Api/Service.api";
import { partnerApi } from "./Api/Partner.api";
import { handleServerErrors } from "../Utils";
import { InquiriesApi } from "./Api/Inquiries";

const authMiddleware =
  ({ dispatch, getState }: any) =>
  (next: any) =>
  (action: any) => {
    if (action.type.includes("Mutation")) {
      if (action.type.endsWith("fulfilled")) {
        // Successful mutation
        const successMessage =
          action?.payload?.response?.message || "عملیات با موفقیت انجام شد.";
        toast.success(successMessage);
      } else if (action.type.endsWith("rejected")) {
        // Failed mutation
        const state = getState();
        const setError = state.settings?.onError;

        const errorMessage = action?.payload || "خطای غیرمنتظره رخ داده است.";
        handleServerErrors(errorMessage, setError);
      }
    }

    if (
      action.payload &&
      action.payload.status === 401 &&
      !window.location.pathname.includes("/auth")
    ) {
      localStorage.removeItem("token");
      window.location.href = "/auth";
    }

    return next(action);
  };

const store = configureStore({
  reducer: {
    auth: authReducer,
    settings: settingsReducer,
    drawer: drawerReducer,
    user: userReducer,
    gateway: gatewayReducer,
    ticket: ticketReducer,
    [api.reducerPath]: api.reducer,
  },
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(authApi.middleware)
      .concat(adminApi.middleware)
      .concat(bankApi.middleware)
      .concat(gatewayApi.middleware)
      .concat(ticketApi.middleware)
      .concat(addressApi.middleware)
      .concat(transactionApi.middleware)
      .concat(marketingApi.middleware)
      .concat(walletApi.middleware)
      .concat(withdrawApi.middleware)
      .concat(gatewayAdminApi.middleware)
      .concat(newsApi.middleware)
      .concat(eventApi.middleware)
      .concat(serviceApi.middleware)
      .concat(partnerApi.middleware)
      .concat(InquiriesApi.middleware)
      .concat(authMiddleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
